import Vue from 'vue';
import Vuex from 'vuex';
import Login from './login/index';
import User from './user/index'
import Postcode from './user/psotcode'
import Shop from './shop/index'
import Member from './member/index'
import Class from './class/index'
import Product from './product/index'
import Bundle from './bundle/index'
import File from './file/index'
import Coupon from './coupon'
import Order from './order/index'
import Notice from './notice/index'
import Performance from './performance/index'
import MemberPoint from './memberpoint/index'
import MemberGift from './membergift/index'
import Permission from './permission/index'


Vue.use(Vuex);

 const store = new Vuex.Store({
  modules: {
          Login,
          User,
          Postcode,
          Shop,
          Member,
          Class,
          Product,
          Bundle,
          File,
          Coupon,
          Order,
          Notice,
          Performance,
          MemberPoint,
          MemberGift,
          Permission
  }
});

export default store;